import React from 'react'
import "../ban/Ban.css"
const Ban = () => {
  return (
    <>
    <section id="ban">
      <div class="container">
        <div class="ban_main">
          <h1>Anout us</h1>
          <h6>Home-Shop Category</h6>
        </div>
      </div>
    </section>
    </>
  )
}

export default Ban